export default __webpack_public_path__ + "static/media/toinhabrasilshow-pub-300x225.347ecbb3.png";